import { useElementSize as v } from "@vueuse/core";
import { defineComponent as w, ref as x, computed as r, openBlock as n, createElementBlock as i, normalizeClass as o, toDisplayString as c, createCommentVNode as a, createElementVNode as t, normalizeStyle as _, Fragment as C, createTextVNode as z } from "vue";
import { _ as L } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var m = /* @__PURE__ */ ((e) => (e.Circular = "circular", e.Linear = "linear", e.Text = "text", e))(m || {}), k = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Danger = "danger", e.Inherit = "inherit", e))(k || {}), s = /* @__PURE__ */ ((e) => (e.M = "m", e.S = "s", e))(s || {});
const $ = [
  // Layout
  "flex",
  "flex-col",
  "gap-md"
], b = {
  primary: [
    // Theme
    "stroke-primary",
    "dark:stroke-primary-dark"
  ],
  danger: [
    // Theme
    "stroke-error",
    "dark:stroke-error-dark"
  ],
  inherit: []
}, W = [
  "flex",
  "justify-center"
], B = [
  "typography-headline-2",
  "text-center",
  "text-on-background",
  "dark:text-on-background-dark"
], D = [
  "typography-body-2-regular",
  "text-center",
  "text-outline",
  "dark:text-outline-dark"
], E = w({
  name: "OrLoader",
  props: {
    variant: {
      type: String,
      default: () => m.Circular
    },
    /**
     * Defines a semantic color of the loading indicator.
     * Use `'inherit'` option to set your own color from the parent (not recommended).
     */
    color: {
      type: String,
      default: () => k.Primary
    },
    /**
     * Defines a diameter of the circular loader. Ignored for linear one.
     */
    size: {
      type: String,
      default: () => s.M
    },
    title: {
      type: String,
      default: void 0
    },
    description: {
      type: String,
      default: void 0
    },
    text: {
      type: String,
      default: "Loading"
    }
  },
  expose: [
    "root"
  ],
  setup(e) {
    const l = x(), { width: d } = v(l), u = r(() => [
      "or-loader-v3",
      ...$,
      ...b[e.color]
    ]), p = r(() => [
      ...B
    ]), y = r(() => [
      ...D
    ]), g = r(() => [
      ...W
    ]), h = r(() => {
      switch (e.size) {
        case s.M:
          return 20;
        case s.S:
          return 16;
      }
    }), f = r(() => d.value ? d.value - 2 : "100%"), S = r(() => `min-width: ${h.value}px;`);
    return {
      root: l,
      rootStyles: u,
      containerStyles: g,
      titleStyles: p,
      descriptionStyles: y,
      computedSize: h,
      strokeWidth: f,
      wrapperStyle: S
    };
  }
}), M = ["width", "height"], N = {
  fill: "none",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, O = ["stroke"], T = {
  key: 1,
  width: "100%",
  height: "4"
}, P = {
  fill: "none",
  "stroke-width": "4",
  "stroke-linecap": "round"
}, R = ["x2"], j = ["x2", "stroke"], A = /* @__PURE__ */ t("span", { class: "animate-pulse" }, ".", -1), F = /* @__PURE__ */ t("span", { class: "animate-pulse animation-delay-200" }, ".", -1), I = /* @__PURE__ */ t("span", { class: "animate-pulse animation-delay-400" }, ".", -1);
function V(e, l, d, u, p, y) {
  return n(), i("div", {
    ref: "root",
    class: o(e.rootStyles)
  }, [
    e.title ? (n(), i("div", {
      key: 0,
      class: o(e.titleStyles)
    }, c(e.title), 3)) : a("", !0),
    t("div", {
      class: o(e.containerStyles),
      style: _(e.wrapperStyle)
    }, [
      e.variant === "circular" ? (n(), i("svg", {
        key: 0,
        viewBox: "0 0 16 16",
        width: e.computedSize,
        height: e.computedSize
      }, [
        t("g", N, [
          t("circle", {
            class: o([
              "animate-circular-loader",
              "origin-center"
            ]),
            cx: "50%",
            cy: "50%",
            r: "7",
            stroke: e.color === "inherit" ? "currentColor" : "inherit"
          }, null, 8, O)
        ])
      ], 8, M)) : a("", !0),
      e.variant === "linear" ? (n(), i("svg", T, [
        t("g", P, [
          t("line", {
            class: o([
              "stroke-surface-variant",
              "dark:stroke-surface-variant-dark"
            ]),
            x1: "2",
            y1: "50%",
            x2: e.strokeWidth,
            y2: "50%"
          }, null, 8, R),
          t("line", {
            class: o([
              "animate-linear-loader",
              "origin-center"
            ]),
            x1: "2",
            y1: "50%",
            x2: e.strokeWidth,
            y2: "50%",
            stroke: e.color === "inherit" ? "currentColor" : "inherit"
          }, null, 8, j)
        ])
      ])) : a("", !0),
      e.variant === "text" ? (n(), i(C, { key: 2 }, [
        z(c(e.text) + " ", 1),
        A,
        F,
        I
      ], 64)) : a("", !0)
    ], 6),
    e.description ? (n(), i("div", {
      key: 1,
      class: o(e.descriptionStyles)
    }, c(e.description), 3)) : a("", !0)
  ], 2);
}
const J = /* @__PURE__ */ L(E, [["render", V]]);
export {
  m as L,
  J as O,
  k as a,
  s as b
};
//# sourceMappingURL=OrLoader-2SaTMxmZ.mjs.map
